<script context='module' lang='ts'>
  import { getContext, setContext } from "svelte";

  const container = writable<DOMRect>({});
  const current = writable<DOMRect>({});

  const wizardContainer = (node: HTMLElement) => {
    container.set(node.getBoundingClientRect());
  }

  export const wizard = (node: HTMLElement) => {
    const c = get(container);
    if (!c) return;
    const bbox = node.getBoundingClientRect();
    current.set({
      ...bbox,
      top: bbox.top - c.top,
      left: bbox.left - c.left,
      bottom: bbox.bottom - c.bottom,
      right: bbox.right - c.right,
    });
    return {
      destroy() {}
    }
  }

  const wizardKey = Symbol('wizard');
  export const getWizard = () => getContext(wizardKey);
</script>

<script lang='ts'>
  import { get, writable } from "svelte/store";
  import Pointer from "~/icons/Pointer.svelte";

  const wizardContext = setContext(wizardKey, [])
</script>

<div
  use:wizardContainer
  class='pointer-container'
>
  <slot />
    <div
      class='pointer'
      style='
        top: {$current.top + $current.height / 2}px;
        left: {$current.left + $current.width / 2}px;
      '
    >
      <Pointer />
    </div>
</div>

<style>
  .pointer-container {
    position: relative;
  }
  .pointer {
    display: none;
    position: absolute;
    z-index: 1000;
  }
</style>